'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Image, TouchableWithoutFeedback, Animated} from 'react-native';
import Icon from '../../../../components/Icon';
import { observer, inject } from 'mobx-react';
import styles from './style';
import {QLinearGradient} from 'qunar-react-native';
import FlightType from './component/flightType';
import CitySelect from './component/citySelect';
import { QToast } from '@qnpm/q-components';
import QImageSet from '../../../../assets/QImageSet';
import {jump} from '../../../../common/hysdkUtils/jump';
import { getQueryParam } from '../../../../models/search/util';

@inject(stores => {
    const {searchDataStore, lowPriceDataStore} = stores,
        {handleSearchFilter, jumpUrl, depCity, arrCity, userSelectStr, initUserSelect, initCityList, flightType, userSelect, initFlightType, goToGlobalPrice} = searchDataStore,
        {fixedSearchBoxVisible, handleFixedSearchBox} = lowPriceDataStore;
    return {
        jumpUrl,
        depCity,
        arrCity,
        userSelect,
        flightType,
        initFlightType,
        initCityList,
        userSelectStr,
        initUserSelect,
        handleSearchFilter,
        fixedSearchBoxVisible,
        handleFixedSearchBox,
        goToGlobalPrice
    };
})

@observer
class SearchBox extends Component {
    constructor(props) {
        super(props);
    }


    handleSearchFlight = () => {
        let {depCity, arrCity, flightType, userSelect, userSelectStr, goToGlobalPrice} = this.props || {};
        const {weeks, days, tag} = userSelect;
        const appId = getQueryParam('appId')

        if(!depCity && !arrCity) {
            QToast.show('请选择出发地、到达地');
            return;
        } else if(!depCity) {
            QToast.show('请选择出发地');
            return;
        } else if(!arrCity) {
            QToast.show('请选择到达地');
            return;
        } else if (appId && goToGlobalPrice) {
            // 小程序内不支持多地比价
            QToast.show('暂时只支持单目的地查询');
            return;
        }

        GodEye.log({
            r: 'c_search_flight_list',
            flight_type: flightType,
            months: tag,
            weeks,
            days,
            dep: depCity,
            arr: arrCity,
            tag_names: userSelectStr,
            is_round: flightType === 2,
            is_inter: false,
            cat: getQueryParam('cat') || ''
        });

        this.props.jumpUrl && jump({
            url: this.props.jumpUrl,
            onViewBack: () => {
                this.props.initFlightType();
                this.props.initCityList();
                this.props.initUserSelect();
            }
        })
    };
    render() {
        const {fixedSearchBoxVisible} = this.props;
        return (
            <TouchableWithoutFeedback>
            <View style={[styles.searchBoxWrapper, fixedSearchBoxVisible ? styles.noShadow : {}]}>
                <FlightType/>
                <View style={styles.searchBoxMainContainer}>
                    <CitySelect/>
                    <TouchableOpacity style={[styles.searchFilterBox, fixedSearchBoxVisible ? {} : {}]} onPress={() => {
                        this.props.handleSearchFilter('show');
                        GodEye.log({
                            r: 'c_range_time_click',
                            flight_type: this.props && this.props.flightType
                        });
                    }}>
                        <Text style={styles.searchFilterText}
                              numberOfLines={1}
                              ellipsizeMode={'tail'}
                        >{this.props.userSelectStr}</Text>
                        <Icon name='rightArrow' color='#999999' size={18} style={styles.searchFilterIcon}/>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={this.handleSearchFlight}>
                        <QLinearGradient
                            style={styles.searchButton}
                            colors={['rgba(38, 194, 141, 10)', 'rgba(38, 194, 141, 99)']}
                            end={{x: 1.0, y: 1.0}}
                            start={{x: 1.0, y: 0.0}}
                        >
                            <Image source={{uri: QImageSet.searchBg}}
                                   style={[styles.searchButton, {position: 'absolute', marginTop:0}]}/>
                            <Text style={styles.searchButtonText}>搜索低价机票</Text>
                            <Image source={{uri: QImageSet.shadowButton}} style={styles.shadowButton}/>
                        </QLinearGradient>
                    </TouchableOpacity>
                </View>
            </View>
            </TouchableWithoutFeedback>

        )
    }
}

export default SearchBox;
